/**
 * 404.
 *
 * Kullaniciyi cikmazda birakmiyoruz: ana sayfaya donus HER ZAMAN var.
 * "Sayfa bulunamadı" tek basina, geri tusunu bulmayi kullaniciya birakir.
 */

import { Link } from 'react-router-dom';
import { Card, EmptyState } from '@/components/ui';
import { copy, useI18n } from '@/lib/i18n';

export default function NotFound() {
  const { language } = useI18n();
  const c = (tr: string, en: string) => copy(language, tr, en);
  return (
    <Card>
      <EmptyState
        icon="?"
        title={c('Sayfa bulunamadı', 'Page not found')}
        description={c('Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.', 'The page you are looking for may have moved or may never have existed.')}
        action={
          <Link className="btn btn--primary btn--md" to="/">{c('Ana sayfaya dön', 'Return home')}</Link>
        }
      />
    </Card>
  );
}
